import "./TopBar.css";

export default function TopBar({ userList, connected, myName, onLogout, openChat, currentUser }) {
    return (
        <div className="topbar">

            {/* Header */}
            <div className="topbar-header">
                <button className="logout-btn" onClick={onLogout}>
                    Sair
                </button>

                <div className="connection-status">
                    <div className="status-dot" style={{
                        backgroundColor: connected ? "#4caf50" : "#f44336"
                    }} />
                    {connected ? `${myName} online` : "Desconectado"}
                </div>
            </div>

            {/* Lista horizontal */}
            <div className="userlist-horizontal">
                {userList?.map((user, index) => (
                    user.uid !== currentUser?.uid && (
                        <div
                            key={index}
                            className="user-card"
                            onClick={() => openChat({ myUid: currentUser.uid, otherUid: user.uid })}
                        >
                            <img
                                className="user-avatar"
                                src={user.profileUrl || "https://img.icons8.com/ios/452/user-male-circle.png"}
                                alt="avatar"
                            />
                            <div className="user-name">{user.name}</div>
                        </div>
                    )
                ))}
            </div>

        </div>
    );
}